import { useMutation, useQueryClient } from "react-query";
import { useContext } from "react";
import { FetchContext } from "../context/FetchContext";

export const useAddProjectContributors = (projectId) => {
  const fetchContext = useContext(FetchContext);
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      await fetchContext.authAxios.post(
        `/projects/${projectId}/contributors`,
        data
      );
    },
    {
      onSettled: () => {
        queryClient.invalidateQueries([
          "project",
          projectId.toString(),
          "contributors",
        ]);
      },
    }
  );
};
